const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
export function parseContentDispositionFilename(value: string): string | undefined {
  if (value && value.indexOf("attachment") !== -1) {
    const matches = filenameRegex.exec(value);
    if (matches !== null && matches[1]) {
      return matches[1].replace(/['"]/g, "");
    }
  }
  return undefined;
}
